import { render, staticRenderFns } from "./InstructorSelect.vue?vue&type=template&id=3c1670f2&scoped=true&"
import script from "./InstructorSelect.vue?vue&type=script&lang=js&"
export * from "./InstructorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1670f2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1670f2')) {
      api.createRecord('3c1670f2', component.options)
    } else {
      api.reload('3c1670f2', component.options)
    }
    module.hot.accept("./InstructorSelect.vue?vue&type=template&id=3c1670f2&scoped=true&", function () {
      api.rerender('3c1670f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/program/components/InstructorSelect.vue"
export default component.exports